// extracted by mini-css-extract-plugin
export default {"resetPassword":"resetPassword_resetPassword__t5cSO","resetPasswordInput":"resetPassword_resetPasswordInput__J4dkI"};